import React from 'react'
import {FaFacebookF,FaWhatsapp,FaInstagram} from "react-icons/fa"
import {} from "react-icons/fa"


const SocialMedia = () => {
  return (
    <div className='social-media'>
        <a href="https://www.facebook.com/people/Financiera-Financiatodo/100086600317840/"><FaFacebookF size="25px" /></a>
        <a href="https://www.instagram.com/financiatodopa/" target="__blank"><FaInstagram size="25px" /></a>
        <a href="https://wa.me/50764714369?text=Hola%20Financiatodo!%20Quiero%20solicitar%20un%20prestamo.%20"><FaWhatsapp size="25px" /></a>
    </div>
  )
}

export default SocialMedia
